// extracted by mini-css-extract-plugin
export default {"topSidebar":"DvdPJxv9OoEOVFTvnInp"};